import React, { useState } from "react";
import { Input } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import SearchableField from "../../components/searchableField/searchableField";
import { SearchableModalProps } from "../../types/field";
import CustomIcon from "../../components/icons/CustomIcon";

interface Props {
    title: string;
    placeholder: string;
    onChange?: any;
    disabled?: boolean;
    data?: any;
    className?: string;
    rules?: any;
    setValue?: any;
    setError?: any;
    control?: any;
    name: string;
    pattern?: any;
    onBlur?: any;
    searchModalProps: SearchableModalProps;
}
const SearchableInputComponent: React.FC<Props> = ({
    title,
    placeholder,
    onChange,
    disabled,
    data,
    className,
    setValue,
    setError,
    rules,
    control,
    name,
    pattern,
    onBlur,
    searchModalProps,
}) => {

    const [openFieldSearchableModal, setOpenFieldSearchableModal] = useState(false);

    const [selected, setSelected] = useState<string>(data ? data : null);

    // useEffect(() => {
    //     if (data !== undefined && data !== null) {
    //         setValue(name, data);
    //         if (onChange) {
    //             onChange(data);
    //         }
    //     }
    // }, [data]);

    const handleClearButtonClick = (e: any) => {
        e.stopPropagation(); // Prevent click event from reaching the input field
        setValue(name, "");
        onChange("");
    };

    return (

        <>
            <Input

                title={title}
                placeholder={placeholder}
                disabled={disabled}
                className={className}

                value={selected}
                name={name}
                onChange={(value: any) => { onChange(value) }}
                suffix={
                    selected && selected !== "" ?
                        (
                            <span
                                style={{ cursor: "pointer" }}
                                onClick={handleClearButtonClick}
                            >
                                <CloseCircleOutlined rev={undefined} />
                            </span>
                        ) : (
                            <CustomIcon name="searchLens"></CustomIcon>
                        )
                }
                onMouseDown={() => { setOpenFieldSearchableModal(true) }}
                onClick={() => { setOpenFieldSearchableModal(true) }}
                onFocus={() => { setOpenFieldSearchableModal(true) }}

                maxLength={title === "email" ? 50 : (Number(rules?.maxSize) ?? 1000)}

            />
            {openFieldSearchableModal ? (
                <SearchableField
                    onSelection={(val: any) => { setSelected(val); setOpenFieldSearchableModal(false); onChange(val); }}
                    onCancel={() => { setOpenFieldSearchableModal(false); }}
                    fieldId={searchModalProps.fieldIdtoMapFromBluePrint}
                    title={searchModalProps.searchModalTitle}
                    dataTableBluePrint={searchModalProps.dataTableBluePrint}
                    searchBluePrint={searchModalProps.searchFilterBluePrint}
                />
            ) : (<></>)}

        </>

    );
};

export { SearchableInputComponent };
